var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLanguage = function SvgLanguage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 5v18h5v5.094l1.625-1.313L14.344 23H29V5zm2 2h22v14H13.656l-.281.219L10 23.906V21H5zm4.219 2L9 9.688l-1.938 6-.062.156V17h2v-.875L9.031 16h1.938l.031.125V17h2v-1.156l-.063-.156-1.937-6L10.781 9zM20 11v1h-3v2h4.438c-.168.29-.356.594-.594.906-.074.098-.168.188-.25.281-.489-.449-.844-.843-.844-.843l-1.5 1.312s.324.348.813.813A4.248 4.248 0 0117 17v2c1.477 0 2.71-.496 3.688-1.188C21.608 18.45 22.718 19 24 19v-2c-.527 0-1.18-.258-1.813-.625.079-.098.176-.188.25-.281A9.417 9.417 0 0023.657 14H25v-2h-3v-1zm-10 2.063l.313.937h-.626z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLanguage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/language.09cd4878.svg";
export { ForwardRef as ReactComponent };